import { useEffect, useMemo, useRef } from 'react'

import { listScoutAccounts, resolveScoutAccountConnectionStatus } from '../../services/scout'

const buildAccountsSignature = (accounts = []) => {
	return JSON.stringify(
		accounts
			.map((account) => ({
				id: String(account?.id || ''),
				phoneNumber: String(account?.phone_number || ''),
				status: resolveScoutAccountConnectionStatus(account),
				isActive: Boolean(account?.isActive),
			}))
			.sort((first, second) => first.id.localeCompare(second.id)),
	)
}

export const useHomeAccountsPolling = ({ accounts, accountsLoading, onRefresh, fetchAccounts = listScoutAccounts, interval = 10000 }) => {
	const signature = useMemo(() => buildAccountsSignature(accounts), [accounts])
	const latestSignatureRef = useRef(signature)
	const onRefreshRef = useRef(onRefresh)
	const fetchAccountsRef = useRef(fetchAccounts)

	useEffect(() => {
		latestSignatureRef.current = signature
	}, [signature])

	useEffect(() => {
		onRefreshRef.current = onRefresh
	}, [onRefresh])

	useEffect(() => {
		fetchAccountsRef.current = fetchAccounts
	}, [fetchAccounts])

	useEffect(() => {
		if (accountsLoading) {
			return undefined
		}

		let isActive = true

		const intervalId = window.setInterval(async () => {
			try {
				const nextAccounts = await fetchAccountsRef.current()
				const nextSignature = buildAccountsSignature(nextAccounts)

				if (!isActive || nextSignature === latestSignatureRef.current) {
					return
				}

				latestSignatureRef.current = nextSignature
				onRefreshRef.current?.(nextAccounts)
			} catch {
				
			}
		}, interval)

		return () => {
			isActive = false
			window.clearInterval(intervalId)
		}
	}, [accountsLoading, interval])
}
